<template>
  <div class="pa-3">
    <loader v-show="$wait.is('getTypes')"></loader>
    <v-container v-show="!$wait.is('getTypes')">
     <div class="d-flex flex-column">
        <div style="width: 100%" :class="hasAdminRights && getDeviceType === 'touch' ? 'd-flex justify-space-between' : ''">
         <span class="headline font-weight-light"> Tipovi radova </span>
      </div>
       <div
          class="d-flex justify-space-between pt-3"
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
        >
          <div
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'min-width: 400px; max-width: 800px'
                : 'width:100%'
            "
          >
            <v-text-field
              dense
              label="Traži"
              v-model="searchTypes"
              outlined
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </div></div>
     </div>
      <v-data-table
        :headers="headers"
        :search="searchTypes"
        :items="getTipovi"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        mobile-breakpoint="0"
        :items-per-page="getTypes.per_page"
        hide-default-footer
        
        item-key="naziv"
        show-expand
        class="elevation-1 curs"
        no-data-text="Nema podataka"
        no-results-text="Nema podataka"
        loading-text="Učitavanje..."
      >


        <template v-slot:[`item.data-table-expand`]="props">
          <v-btn
            :disabled="!props.item.vrste_rada.length"
            @click="expandRow(props.item)"
            icon
          >
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0 ma-0 pt-0 pb-0 mt-0 mb-0 pl-0">
            <div v-for="n in item.vrste_rada" :key="n.id">
              <v-row>
                <v-col cols="12">
                  <span
                    class="pa-0 pt-2 pl-10 ml-12"
                    style="
                      font-style: normal;
                      font-size: 14px;
                      font-weight: normal;
                    "
                    >{{ n.naziv }}
                  </span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </td>
        </template>

      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-if="getTypes.last_page!=1"
          v-model="page"
          total-visible="20"
          @input="goTo"
          :length="getTypes.last_page"
        ></v-pagination>
      </div>
     
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";
export default {
  metaInfo: {
    title: "Tipovi radova  - Registar radova",
  },
  data: () => ({
    name: "TipoviRada",
    searchTypes: "",
    dialog: false,
    typesDialog: false,
    page: 1,
    types: [],

    headers: [
      {
        text: "Naziv",
        align: "start",
        value: "naziv",
        sortable: false,
      },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],

    expanded: [],
    singleExpand: false,
    editedIndex: -1,
    odabraniTip: {},
  }),

  computed: {
    ...mapGetters(["getTypes", "getDeviceType", "hasAdminRights"]),
    getTipovi() {
      if (this.getTypes) {
        return this.getTypes.data;
      } else {
        return [];
      }
    },
  },
  methods: {
    expandRow(item) {
      if (!this.expanded.includes(item)) {
        this.expanded.push(item);
      } else {
        this.expanded = this.expanded.filter((i) => i != item);
      }
    },
    goTo(item) {
      this.page = item;
      waitFor("getTypes", async function () {
        await this.$store.dispatch("getTypes", item);
      }).apply(this);
    },
  },
  beforeMount() {
    waitFor("getTypes", async function () {
      await this.$store.dispatch("getTypes", 1);
    }).apply(this);
  },
};
</script>
<style lang="scss">
.curs > .v-data-table__wrapper > table tbody td {
  cursor: context-menu !important;
}
</style>